import { getFromApiFunction } from "../apiFunctions";

const getInterventions = async (params: URLSearchParams = new URLSearchParams()) => {
  const endPoint = "/interventions/";
  return getFromApiFunction(endPoint, params);
};

export { getInterventions };
